import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import moment from "libs/moment";
import RingCountdown from "components/complex/countdown/RingCountdown";
import Workspace from "components/Workspace";
import Tr from "../../../../../../translations/Translations";

function StatisticSection(
    {
        endTimeCallback,
        currentRfxRound
    }) {


    const [durations, setDurations] = useState([]);


    useEffect(() => {
        if (!currentRfxRound) {
            return;
        }
        const end = moment(currentRfxRound.offerEndDate);
        const nowTime = moment(currentRfxRound.now);
        if (currentRfxRound.offerCollectionEnded) {
            setDurations([0, 0]);
            return;
        }

        const duration2 = moment.duration(end.diff(nowTime));
        const number = duration2.asSeconds();

        const startTime = moment(currentRfxRound.offerStartDate);
        const startDuration = moment.duration(end.diff(startTime));
        const startNumber = startDuration.asSeconds();

        setDurations([number, startNumber]);
    }, [currentRfxRound]);

    return (
        <Workspace
            render={
                <>
                    {!durations.length || <RingCountdown duration={durations[0]} baseDuration={durations[1]} endTimeCallback={endTimeCallback} title={Tr("left_to_offer_end_date")}/>}
                </>}/>
    )

}

StatisticSection.propTypes = {
    demandStatistics: PropTypes.object,
    endTimeCallback: PropTypes.func,
}

StatisticSection.defaultProps = {
    endTimeCallback: () => {
    },
}

export default StatisticSection;